import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import BookCover from './BookCover';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiStar } = FiIcons;

const Hero = () => (
  <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden">
    {/* Ambient background */}
    <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-amber-50 via-brand-light to-stone-100 pointer-events-none" />
    <div className="absolute top-20 right-0 w-96 h-96 bg-brand-accent/10 blur-3xl rounded-full pointer-events-none" />

    <div className="max-w-7xl mx-auto px-6 relative z-10">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">

        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="max-w-2xl"
        >
          {/* Social proof badge */}
          <div className="inline-flex items-center gap-2 bg-white border border-amber-200 rounded-full px-4 py-2 mb-6 shadow-sm">
            <div className="flex">
              {[...Array(5)].map((_, i) => <FiStar key={i} className="text-amber-400 fill-amber-400" size={12} />)}
            </div>
            <span className="text-xs text-slate-600 font-medium">Readers worldwide are transforming their relationships</span>
          </div>

          <h2 className="text-brand-accent font-semibold tracking-widest uppercase text-sm mb-4">Now Available — Book by Andrei Ciomîrtan</h2>
          <h1 className="text-5xl lg:text-6xl xl:text-7xl font-serif font-bold text-brand-dark leading-[1.05] mb-6">
            Finally Understand<br />
            <span className="text-brand-accent italic">the Man You Love.</span>
          </h1>
          <p className="text-lg text-slate-600 mb-8 leading-relaxed max-w-lg">
            <em>How to Love a Good Man</em> reveals the 8 essential truths of the male heart — a profound guide to bridging the silent gap and building the deep, lasting connection you deserve.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://www.amazon.com/dp/B0GTJHV5BB"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex justify-center items-center gap-2 bg-brand-accent text-white px-8 py-4 rounded-full font-medium hover:bg-brand-accentHover transition-colors duration-300 text-lg shadow-lg shadow-brand-accent/30"
            >
              Get Your Copy <FiArrowRight />
            </a>
            <Link
              to="/chapters"
              className="inline-flex justify-center items-center gap-2 bg-white text-brand-dark border border-slate-200 px-8 py-4 rounded-full font-medium hover:bg-slate-50 transition-colors duration-300 text-lg"
            >
              Explore the Book
            </Link>
          </div>

          <div className="flex gap-8 mt-10 pt-8 border-t border-slate-200">
            {[['8', 'Essential Truths'], ['4.9★', 'Avg. Rating'], ['3', 'Formats Available']].map(([val, label]) => (
              <div key={label}>
                <div className="text-2xl font-serif font-bold text-brand-dark">{val}</div>
                <div className="text-xs text-slate-500 mt-0.5">{label}</div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.4 }}
          className="mx-auto lg:ml-auto"
        >
          <BookCover size="md" />
        </motion.div>

      </div>
    </div>
  </section>
);

export default Hero;